import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Box } from '@chakra-ui/react';
import { Link } from '../Link';

export default function DownloadLinks(props) {
  const { downloads } = useStaticQuery(DOWNLOADS_QUERY);
  const { variant, ...restProps } = props;

  return (
    <Box {...restProps}>
      {downloads.links.map((link) => (
        <Link
          to={{
            internal: {
              section: 'single',
              slug: {
                current: link.slug.current,
              },
            },
          }}
          key={link.slug.current}
          variant={variant || 'primary'}
        >
          {link.displayTitle}
        </Link>
      ))}
    </Box>
  );
}

const DOWNLOADS_QUERY = graphql`
  query Downloads {
    downloads: allSanityDownload {
      links: nodes {
        displayTitle
        slug {
          current
        }
      }
    }
  }
`;
